import axios from "axios";
import { postRequest, getRequest } from "../../utils/apiHelper";
import { setNotifications } from "./notificationsSlice";

export const fetchNotifications = (technicianId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    try {
      getRequest(
        `/api/notification/GetNotifications?technicianId=${technicianId}`
      )
        .then((res) => {
          dispatch(setNotifications(res?.data));
          resolve(res.data);
        })
        .catch((err) => {
          const message =
            err?.response?.data ||
            err?.message ||
            "Failed to fetch notifications";
          reject(message);
        });
    } catch (error) {
      reject("Unexpected error occurred while fetching notifications");
    }
  });
};

export const markNotificationAsRead = (notificationId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    try {
      postRequest(
        `api/notification/markasread?notificationId=${notificationId}`
      )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          const message =
            err?.response?.data ||
            err?.message ||
            "Failed to mark notification as read";
          // Optionally dispatch a global error here
          reject(message);
        });
    } catch (error) {
      reject("Unexpected error occurred while marking notification as read");
    }
  });
};

export const acceptJob = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    try {
      postRequest(`/api/Appointment/UpdateTechnicianStatus`, payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          const message =
            err?.response?.data || err?.message || "Failed to accept job";
          reject(message);
        });
    } catch (error) {
      reject("Unexpected error occurred while accepting job");
    }
  });
};

export const registerDeviceToken =
  (technicianId, token, platform) => (dispatch) => {
    return new Promise((resolve, reject) => {
      try {
        postRequest("api/notification/RegisterDeviceToken", {
          technicianId: technicianId,
          token: token,
          platform: platform,
          // Remove the "obj" wrapper
        })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            const message =
              err?.response?.data?.message ||
              err?.message ||
              "Failed to register device token";
            reject(message);
          });
      } catch (error) {
        reject("Unexpected error occurred while registering device token");
      }
    });
  };
